import { Currency } from '../../../constants';

export const PAGE_QUERY_KEYS = {
  default: () => ['page'] as const,
  meta: (pathname?: string, currency?: Currency) => [...PAGE_QUERY_KEYS.default(), 'meta', pathname, currency] as const,
  collectionDetail: (slug?: string) => [...PAGE_QUERY_KEYS.default(), 'collectionDetail', slug] as const,
};
